// extracted by mini-css-extract-plugin
export var pillWrapper = "_ox-0";
export var showOverflow = "_ox-1";